import { DefaultError, useMutation, useQuery } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { ICurrency } from 'services/enums/types';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { ISettingsMutation, ISettingsResponse } from './types';

export const useAppSettings = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ISettingsResponse, DefaultError>({
    queryKey: ['app-settings'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'Configuration/GetApplicationConfiguration',
      });

      return responseHandler(response, {
        groupName: 'useAppSettings',
      });
    },
  });
};
export const useDefaultCurrency = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<ICurrency, DefaultError>({
    queryKey: ['default-currency'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: 'Configuration/GetDefaultCurrency',
      });

      return responseHandler(response, {
        groupName: 'useDefaultCurrency',
        onNotFound: () => {},
      });
    },
  });
};

export const useUpdateAppSettings = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('useUpdateAppSettings');

  return useMutation<ISettingsResponse, DefaultError, ISettingsMutation>({
    mutationKey: ['update-app-settings'],
    mutationFn: async body => {
      loading(
        i18next.t('service-message.update.loading', {
          what: i18next.t('setting.updating-app-settings'),
        })
      );

      const response = await apiClient({
        method: 'POST',
        url: 'Configuration/SetApplicationConfiguration',
        body,
      });

      return responseHandler(response, {
        groupName: 'useUpdateAppSettings',
      });
    },
    onSuccess: data => {
      success(i18next.t('toast-message.settings-has-been-updated'));
    },
    onError: dismiss,
  });
};
